import { useEffect, useState } from "react";
import { ChevronDown, RotateCcw, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { http, errMsg } from "../../lib/api";

const NAMES = { "": "Kit Register", founders: "Founder's Register", extras: "Extras Register", bespoke: "Bespoke Register" };
const UNDO = { extras: (id) => `/extras/register/undo/${id}`, bespoke: (id) => `/bespoke/requests/undo/${id}`, register: (id) => `/register/rows/undo/${id}` };
const ago = (iso) => {
  const m = Math.max(1, Math.round((Date.now() - new Date(iso)) / 60000));
  return m < 60 ? `${m} min ago` : `${Math.round(m / 60)} h ago`;
};

export const RecentlyDeleted = ({ tab, version, onRestored }) => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const load = () => http.get("/register/trash").then(({ data }) => setItems(data.filter((t) => t.register === NAMES[tab]))).catch(() => {});
  useEffect(() => { load(); }, [tab, version]); // eslint-disable-line react-hooks/exhaustive-deps
  const restore = (t) => http.post(UNDO[t.kind](t.id))
    .then(() => { toast.success(`${t.name} restored`); load(); onRestored(); }).catch((e) => toast.error(errMsg(e)));
  if (!items.length) return null;
  return (
    <div data-testid="recently-deleted" className="rounded-xl border border-stone-200 bg-white mb-6">
      <button data-testid="recently-deleted-toggle" onClick={() => setOpen(!open)} className="w-full flex items-center gap-2 px-5 py-3 text-sm">
        <Trash2 size={14} className="text-stone-400" /><span className="font-medium">Recently deleted</span>
        <span data-testid="recently-deleted-count" className="text-stone-500">{items.length} in the last day</span>
        <ChevronDown size={14} className={`ml-auto text-stone-500 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <ul className="border-t border-stone-100 divide-y divide-stone-100">
        {items.map((t) => (
          <li key={t.id} data-testid={`deleted-${t.id}`} className="flex items-center gap-4 px-5 py-2.5 text-sm">
            <div className="min-w-0 flex-1">
              <div className="font-medium truncate">{t.name}</div>
              <div className="text-xs text-stone-500 truncate">{[t.detail, t.with && `with ${t.with}`].filter(Boolean).join(" · ")}</div>
            </div>
            <span className="text-xs text-stone-400 whitespace-nowrap">{ago(t.at)}</span>
            <button data-testid={`restore-${t.id}`} onClick={() => restore(t)} className="inline-flex items-center gap-1.5 rounded-sm border border-stone-300 px-3 py-1 text-xs hover:bg-stone-100"><RotateCcw size={12} /> Restore</button>
          </li>
        ))}
      </ul>}
    </div>
  );
};
